import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { ContentRoute,RouteSlotInput  } from '@caritas/ui';
import { navigate } from 'gatsby';

import { useQueryParams } from '../../commons/query-string';
import { useSiteSettings } from '../../commons/site-settings';

export const mapBookingSummary = (pageContext: SilverbackPageContext) =>
  function (): RouteSlotInput<typeof ContentRoute, 'body', 'missionSummary'> {
    return {
      key: 'missionSummary',
      input: function useBookingSummary() {
        const queryParams = useQueryParams();
        const siteSettings = useSiteSettings(pageContext);
        return [
          {
            items:
              typeof queryParams.bookingSummary === 'string'
                ? JSON.parse(queryParams.bookingSummary)
                : [],
            showMissionClick: function () {
              navigate(
                typeof queryParams.locationPath === 'string'
                  ? queryParams.locationPath
                  : '',
              );
            },
            newMissionClick: function () {
              navigate(siteSettings.myProfilePage?.path || '');
            },
          },
          200,
        ];
      },
    };
  };
